import { useCallback, useEffect, useState } from "react";
import { useSelections } from "../../context/Selections";
import { ReactComponent as IconLogoFooter } from "../../assets/icons/footer/logo-footer.svg";

export function Footer({ app }) {
  const [updateDate, setUpdateDate] = useState();
  const { selections } = useSelections();

  const getUpdateDate = useCallback(
    async (objectId) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value = res?.model?.layout?.style?.label;
          setUpdateDate(value);
        });
      }
    },
    [app]
  );

  useEffect(() => {
    if (app) {
      getUpdateDate("LUWhDg");
    }
  }, [app, getUpdateDate, selections]);
  return (
    <footer className="container-footer">
      <div className="text-updateDate">
        <span>{updateDate}</span>
      </div>

      <div className="container-logo-footer">
        <IconLogoFooter />
      </div>
    </footer>
  );
}
